import { useRef, useState } from 'react'
import { Button, Dropdown, Popover, Space } from 'antd'
import { DownOutlined, LoadingOutlined } from '@ant-design/icons'
import Utils from '@utils/utils'
import Iconfont from '@utils/Iconfont'
import PSAIModal from '@PSAIComponents/PSAIModal'
import PickFromProject from '@view/page_v3/AiEdit/components/PickFromProject'
import styles from './index.module.scss'
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

const scaleList = [
    { label: '400%', value: 4 },
    { label: '200%', value: 2 },
    { label: '100%', value: 1 },
    { label: '75%', value: 0.75 },
    { label: '25%', value: 0.25 },
    { label: '15%', value: 0.15 },
]

const ImageResizeBottomToolbar = (props) => {
    const projectListRef = useRef()
    const [open, setOpen] = useState(false)

    const reuploadItems = [
        { label: '本地上传', key: 'local' },
        { label: '从项目选图', key: 'project' },
    ]

    const handleReuploadClick = (e) => {
        const status = Utils.checkLoginStatus(() => handleReuploadClick(e))
        if (!status) return

        if (e.key === 'local') {
            Utils.openFile2(false).then(props.onUpload).catch(() => { })
            return
        }

        setOpen(true)
    }

    const handleOk = async () => {
        const url = await projectListRef.current.onSubmit()
        if (!url) return false
        setOpen(false)
        props.onChange(url)
    }

    const onDoubleClick = async (url) => {
        setOpen(false)
        props.onChange(url)
    }

    const downloadItems = [
        {
            label: <span>PNG <span className={styles.MenuDesc}>透明背景</span></span>,
            key: 'png',
        },
        {
            label: <span>JPG <span className={styles.MenuDesc}>白色背景</span></span>,
            key: 'jpeg',
        }
    ]

    const scaleContent = (
        <div className={styles.ScaleList}>
            {scaleList.map((item) => (
                <p key={item.label} onClick={() => props.onZoomChange(item.value)}>{item.label}</p>
            ))}
        </div>
    )

    return (
        <div className={styles.ToolRow}>
            <div className={styles.ZoomGroup}>
                <button
                    type="button"
                    className={styles.ZoomBtn}
                    onClick={() => props.onZoomChange((props.zoomValue || 1) - 0.1 < 0 ? 0.01 : (props.zoomValue || 1) - 0.1)}
                >
                    <MinusOutlined />
                </button>
                <Popover color="rgba(0,0,0,0.4)" placement="top" content={scaleContent}>
                    <button type="button" className={styles.ZoomValue}>{Math.floor((props.zoomValue || 1) * 100)}%</button>
                </Popover>
                <button type="button" className={styles.ZoomBtn} onClick={() => props.onZoomChange((props.zoomValue || 1) + 0.1)}>
                    <PlusOutlined />
                </button>
            </div>
            <span className={styles.Divider}></span>
            <div className={styles.BtnGroup}>
                <div className={styles.ToolItem} onClick={props.onRemove}>
                    <Iconfont type="icon-Material-DeleteOutlined" className={styles.DeleteIcon} />
                    <span>{'\u5220\u9664'}</span>
                </div>
            </div>
            <span className={styles.Divider}></span>
            <div className={styles.ActionGroup}>
                <Dropdown trigger={['click']} menu={{ items: reuploadItems, onClick: handleReuploadClick }} overlayClassName={styles.Dropdown}>
                    <Button className={styles.BtnPrimary}>
                        <Space>
                            重新上传
                            <DownOutlined className={styles.DropIcon} />
                        </Space>
                    </Button>
                </Dropdown>
                {props.showDownload && (
                    <Dropdown trigger={['click']} menu={{ items: downloadItems, onClick: ({ key }) => props.onDownload(key) }} overlayClassName={styles.Dropdown}>
                        <Button type="primary" className={styles.BtnPrimary}>
                            <Space>
                                <span>{props.downBtnLoading && <LoadingOutlined />} {props.downloadBtnText || '下载图片'}</span>
                                <DownOutlined className={styles.DropIcon} />
                            </Space>
                        </Button>
                    </Dropdown>
                )}
            </div>
            <PSAIModal
                open={open}
                maxWidth={980}
                title="选择图片"
                onOk={handleOk}
                onCancel={() => setOpen(false)}
            >
                <PickFromProject
                    ref={projectListRef}
                    onDoubleClick={onDoubleClick}
                    showAllType
                />
            </PSAIModal>
        </div>
    )
}

export default ImageResizeBottomToolbar
